import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { RoutePath } from '../../../constants/SitePaths'
import Can from '../../../services/permisions/Can'
import { Browser } from '../../../services/helpers/Browser'
import { Menu } from 'antd'
import RolesHelper from '../../../services/permisions/RolesHelper'
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { CloudProviderTypes } from '../../devtools/CloudProvider'
import { useTranslations } from '../../../hooks/useTranslations'

const { SubMenu } = Menu;
function SettingsMenu() {
  const location = useLocation();
  const [selectedMenu, setSelectedMenu] = useState();
  const { translations } = useTranslations();
  const builder = useSelector(state => state.builder);
  const navigate = useNavigate();
  const params = useParams();
  const cloudProvider = builder.projects.selectedProject.cloudProvider;

  const settings_sections = [
    { id: 1, icon: 'overview-bicon', size: 'fi', url: RoutePath.SETTINGS_OVERVIEW, title: translations.overview },
    { id: 2, icon: 'language-bicon', name: 'projectSettings.settingsLanguages', size: 'fi', url: RoutePath.SETTINGS_LANGUAGES, title: translations.languages },
    { id: 4, icon: 'currency-bicon', name: 'projectSettings.settingsCurrencies', size: 'fi', url: RoutePath.SETTINGS_CURRENCIES, title: translations.currencies },
    { id: 3, icon: 'captcha-bicon', name: 'projectSettings.settingsCaptcha', size: 'fi', url: RoutePath.SETTINGS_CAPTCHA, title: translations.captcha },
    ...(cloudProvider != CloudProviderTypes.Nginx ? [{ id: 8, icon: 'domains-bicon', name: 'projectSettings.settingsDomains', size: 'fi', url: RoutePath.SETTINGS_DOMAINS, title: translations.domains, alias: [RoutePath.SETTINGS_ADD_DOMAIN] }] : []),
    {
      id: 9, icon: 'products-bicon', name: 'projectSettings.settingsProducts', size: 'fi', url: `${RoutePath.SETTINGS_PRODUCTS}/sport`, title: translations.products,
      items: [{
        id: 26,
        size: 'fi',
        url: `${RoutePath.SETTINGS_PRODUCTS}/sport`,
        name: 'settingsProducts',
        title: translations.sportsbook
      },
      {
        id: 27,
        size: 'fi',
        name: 'settingsProducts',
        url: `${RoutePath.SETTINGS_PRODUCTS}/casino`,
        title: translations.casino
      }
      ]
    },

    { id: 10, icon: 'third-party-integrations-bicon', name: 'projectSettings.settings3rdparty', size: 'fi', url: RoutePath.THIRD_PARTY_INTEGRATIONS, title: translations.third_party_integrations },
    {
      id: 11,
      icon: 'custom-code-bicon',
      size: 'fi',
      name: 'subpage.customCodes',
      url: `${RoutePath.CUSTOM_SCRIPTS}/script`,
      title: translations.custom_codes,
      className: 'settings_nav_menu',
      items: [{
        id: 12,
        size: 'fi',
        url: `${RoutePath.CUSTOM_SCRIPTS}/script`,
        name: 'settingsCustomScripts',
        title: translations.custom_script
      }, {
        id: 13,
        size: 'fi',
        name: 'settingsCustomStyles',
        url: `${RoutePath.CUSTOM_SCRIPTS}/style`,
        title: translations.custom_styles
      }]
    },
    {
      id: 14,
      icon: 'seo-bicon',
      size: 'fi',
      url: `${RoutePath.SETTINGS_SEO}`,
      title: translations.seo,
      name: 'projectSettings.settingsSEO',
      className: 'settings_nav_menu',
      items: [{
        id: 15,
        size: 'fi',
        name: 'settingsSEO',
        url: `${RoutePath.SETTINGS_SEO}`,
        title: translations.seo_settings,
      }, {
        id: 16,
        size: 'fi',
        name: 'settingsSEO',
        url: `${RoutePath.SETTINGS_SEO_SITEMAP}`,
        title: translations.seo_sitemap,
      },
      {
        id: 17,
        size: 'fi',
        name: 'settingsSEO',
        url: `${RoutePath.SETTINGS_SEO_SOCIAL}`,
        title: translations.seo_social,
      },
      {
        id: 28,
        size: 'fi',
        name: 'settingsSEO',
        url: `${RoutePath.SETTINGS_SEO_ROBOTS}`,
        title: translations.robots,
      }
        // , {
        //   id: 18,
        //   size: 'fi',
        //   name: 'settingsSEO',
        //   url: `${RoutePath.SETTINGS_SEO_SCHEMA_MARKUP}`,
        //   title: translations.seo_schema_markup,
        // }
      ]
    },
    { id: 19, icon: 'add-ons-bicon', name: 'projectSettings.settingsAddOns', size: 'fi', url: RoutePath.ADD_ONS, title: translations.add_ons },
    {
      id: 20,
      icon: 'settings-bicon',
      name: 'subpage.general settings',
      size: 'fi',
      url: `${RoutePath.SETTINGS_LICENSE}`,
      title: translations.general_settings,
      className: 'settings_nav_menu',
      items: [{
        id: 21,
        size: 'fi',
        name: 'settingsLicense',
        url: `${RoutePath.SETTINGS_LICENSE}`,
        title: translations.licenses,
      },
      {
        id: 22,
        size: 'fi',
        name: 'settingsReferAFriend',
        url: `${RoutePath.SETTINGS_REFERRAL_ID}`,
        title: translations.refer_a_friend,
      },
      {
        id: 24,
        size: 'fi',
        url: `${RoutePath.SETTINGS_AGE_RESTRICTION}`,
        name: 'settingsAgeRestriction',
        title: translations.age_restriction,
      }]
    },
    { id: 25, icon: 'dev-tool-bicon', name: 'SuperAdmin', size: 'fi', url: RoutePath.DEV_TOOLS, title: translations.dev_tool },
  ];
  useEffect(() => {
    openSelectedMenu();
  }, [])

  useEffect(() => {
    openSelectedMenu();
  }, [location.pathname])

  function openSelectedMenu() {
    const openedMenu = settings_sections.filter(menuItem => location.pathname === menuItem.url + '/' + params.id ||
      (menuItem.items && menuItem.items.filter(subItem => location.pathname === subItem.url + '/' + params.id).length) ||
      (menuItem.alias && menuItem.alias.filter((a) => location.pathname.includes(a)).length))
    openedMenu[0] && setSelectedMenu([openedMenu[0].id + ""])
  }
  function redirectToSetting(menuItem) {
    const companyId = Browser.getURLParamValue('cid');
    const projectId = params.id;
    navigate(`${menuItem.url}/${projectId}?cid=${companyId}&p=${projectId}`);
  }

  const handleTitleClick = (item) => {
    setSelectedMenu(old => old.indexOf(item.key) >= 0 ? old.filter((i) => i !== item.key) :
      [...old, item.key]
    )
  }

  const defaultSubItems = [];
  const settings_menu = settings_sections.filter(item => ((!item.name && !RolesHelper.isAffilateUser()) || Can({
    I: "view",
    a: `${item.name}`,
    fallback: false,
    children: true
  }))).map(menuItem => {
    if (menuItem.hasOwnProperty('items')) {
      return (
        <SubMenu
          className='sidenav--collapsed-items'
          onTitleClick={handleTitleClick}
          key={menuItem.id}
          title={
            <>
              <i className={`${menuItem.size} ${menuItem.icon}`}></i>
              <span className={`${menuItem.className} tb--mh-10`}>{menuItem.title}</span>
            </>
          }
        >
          {
            menuItem.items && menuItem.items.filter(item => Can({
              I: "view",
              a: `projectSettings.${item.name}`,
              fallback: false,
              children: true
            })).map((subMenuItem, key) => {
              const isSelectedSubItem = location.pathname === subMenuItem.url + '/' + params.id;
              isSelectedSubItem && defaultSubItems.push(subMenuItem.id + "")
              return (
                <Menu.Item className='sidenav--item' onClick={() => redirectToSetting(subMenuItem)} key={subMenuItem.id}>
                  {subMenuItem.title}
                </Menu.Item>
              )
            })
          }
        </SubMenu>
      )
    } else {
      return (
        <Menu.Item key={menuItem.id} onClick={() => redirectToSetting(menuItem)}
          className={`${(location.pathname === menuItem.url + '/' + params.id || (menuItem.alias && menuItem.alias.filter((a) => location.pathname.includes(a)).length)) ? 'sidenav--selected-item' : ''} tb--flex tb--align-center sidenav--item settings_menu_item`}>
          <i className={`${menuItem.size} ${menuItem.icon}`}></i>
          <span className={`${menuItem.className} tb--mh-10`}>{menuItem.title}</span>
        </Menu.Item>
      )
    }
  })
  return (
    <div className="sidenav">
      {RolesHelper.isAffilateUser() ?
        <></>
        : <>
          <a href='/projects' className='go_to_dashboard tb--flex tb--align-center'>
            <i className="arrow-left-bicon"></i>
            <span>{translations.dashboard}</span>
          </a>
          <Can I="view" a="page.uiCustomization">
            <a key={RoutePath.CUSTOMIZE} className='tb--edit-site_btn tb--flex tb--justify-center tb--align-center' onClick={() => redirectToSetting({ url: RoutePath.CUSTOMIZE })}>
              <i className="fi edit-bicon"></i>
              <span>{translations.edit_site}</span>
            </a>
            <div className='edit--site-border'></div>
          </Can>
        </>
      }
      <Menu
        openKeys={selectedMenu}
        selectedKeys={defaultSubItems}
        mode="inline"
      >
        {settings_menu}
      </Menu>
    </div>
  );
}

export default SettingsMenu;